import user1 from "../img/user1.png";
import user2 from "../img/user2.png";
import user3 from "../img/user3.png";



// dummy users "message" 
import chat1 from "../afterLogin picks/home/chat1.png";
import chat2 from "../afterLogin picks/home/chat2.png";
import chat3 from "../afterLogin picks/home/chat3.png";
import chat4 from "../afterLogin picks/home/chat4.png";
import chat5 from "../afterLogin picks/home/chat5.png";


export const Reviews = [
    {
        "id": 1,
        "name": "Andrea Velle",
        "role": "Sports coach",
        "description": "Creating facilities and hosting our trainings in this platform is so much of convenient. We were always looking for this. Job well done.",
        "image": user1
    },
    {
        "id": 2,
        "name": "Nimra",
        "role": "Training User",
        "description": "Understanding my training schedule, tracking my progress and overall improvement areas is all at one place. Hats off!!",
        "image": user2
    },
    {
        "id": 3,
        "name": "Elle Aasen",
        "role": "Training User",
        "description": "Finding a training based on my needs was never so easy. I can see and explore all the available options at my fingertips.",
        "image": user3
    }
]





// Sample user data with image URLs
export const chats = [
  { id: 1, "name": 'John Doe', "message": 'Hello there!',  "image": chat1 },
  { id: 2, "name": 'Jane', "message": 'Hey, how are you?', "image": chat2 },
  { id: 3, "name": 'Jane Smith', "message": 'What\'s up?', "image": chat3 },
  { id: 4, "name": 'Alice', "message": 'Nice weather today, isn\'t it?', "image": chat4 },
  { id: 5, "name": 'Bob', "message": 'How\'s your day going?', "image": chat5 },
  { id: 1, "name": 'John Doe', "message": 'Hello there!',  "image": chat1 },
  { id: 2, "name": 'Jane', "message": 'Hey, how are you?', "image": chat2 },
  { id: 3, "name": 'Jane Smith', "message": 'What\'s up?', "image": chat3 },
  { id: 4, "name": 'Alice', "message": 'Nice weather today, isn\'t it?', "image": chat4 },
  { id: 5, "name": 'Bob', "message": 'How\'s your day going?', "image": chat5 }


    // Add more users if needed
  ];